import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useAddVideoMutation,
  useEditVideoMutation,
  useGetVideoQuery,
} from "../../../features/Admin/Videos/videosApi";
import moment from "moment";
import useForm from "../../../components/controls/useForm";
import { secondToFormatTime } from "../../../utilities/secondToTimeFormat";
import { formatViewToK } from "../../../utilities/formatViewToK";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";
import FormField from "./FormField";
import { timeToSeconds } from "../../../utilities/timeToSeconds";

const initializeValues = {
  title: "",
  description: "",
  url: "",
  views: "",
  duration: "",
  createdAt: "",
};
export default function VideoForm({ isAddForm }) {
  // *****************************************************DECLARATION START******************************************************************************
  const { videoId } = useParams();
  const navigate = useNavigate();

  // REDUX API/SLICE START
  const {
    data: video,
    isLoading: singleVideoIsLoading,
    isSuccess: singleVideoIsSuccess,
    isError: singleVideoIsError,
  } = useGetVideoQuery(videoId, { skip: isAddForm }); // Get Single Video
  const [
    addVideo,
    {
      isLoading: addVideoIsLoading,
      isSuccess: addVideoIsSuccess,
      isError: addVideoIsError,
    },
  ] = useAddVideoMutation(); // Added new Video
  const [
    editVideo,
    {
      isLoading: editVideoIsLoading,
      isSuccess: editVideoIsSuccess,
      isError: editVideoIsError,
    },
  ] = useEditVideoMutation(); // Edit video
  // REDUX API/SLICE END

  const { values, setValues, handleInputChange, resetForm } =
    useForm(initializeValues);

  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect START******************************************************************************
  useEffect(() => {
    if (addVideoIsSuccess || editVideoIsSuccess) {
      resetForm(initializeValues);
      navigate("/admin/videos");
    }
  }, [addVideoIsSuccess, editVideoIsSuccess, navigate]); // Only for Add and edit Form
  useEffect(() => {
    if (singleVideoIsSuccess) {
      // Format Views, Duration, CreatedAt
      const { views, duration } = video || {};
      let acceptedViews = parseFloat(views) * 1000;
      let acceptedDuration = timeToSeconds(duration);
      setValues({
        ...video,
        views: acceptedViews,
        duration: acceptedDuration,
      });
    }
  }, [singleVideoIsSuccess, video]); // Only for Edit Form
  // *****************************************************useEffect END******************************************************************************
  // *****************************************************HANDLE START******************************************************************************
  const handleCancel = () => {
    navigate("/admin/videos");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedCreateAt = moment.utc(values?.createdAt)?.toISOString();
    const formattedViews = formatViewToK(values?.views);
    const formattedDuration = secondToFormatTime(values?.duration);
    isAddForm
      ? addVideo({
          ...values,
          views: formattedViews,
          duration: formattedDuration,
          createdAt: formattedCreateAt,
        })
      : editVideo({
          data: {
            ...values,
            views: formattedViews,
            duration: formattedDuration,
            createdAt: formattedCreateAt,
          },
          id: videoId,
        });
  };
  // *****************************************************HANDLE SUBMIT END******************************************************************************
  // *****************************************************Decided which part render START******************************************************************************
  const formContent =
    addVideoIsLoading || editVideoIsLoading || singleVideoIsLoading ? (
      <Loading />
    ) : (!addVideoIsLoading || !editVideoIsLoading) &&
      (addVideoIsError || editVideoIsError || singleVideoIsError) ? (
      <Error
        header={"System Error !!"}
        message={"Please contract with administrator"}
      />
    ) : (
      <FormField
        isAddForm={isAddForm}
        values={values}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
      />
    );
  // *****************************************************Decided which part render END******************************************************************************
  return (
    <>
      <div className="lg:pl-[14rem] mt-[5.8125rem]">
        <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
          <h1 className="mb-10 text-center lws-section-title">
            {isAddForm ? "Add New Video" : "Edit Video"}
          </h1>

          <div className="max-w-3xl mx-auto">{formContent}</div>
        </main>
      </div>
    </>
  );
}
